(function () {
  const FILTERS_OPEN_CLASS = 'filters-open';
  let filtersOpener = null;

  function isFiltersOpen() {
    return document.documentElement.classList.contains(FILTERS_OPEN_CLASS);
  }

  function getSidebar() {
    return document.getElementById('FacetSidebar');
  }

  function getOpenButtons() {
    return document.querySelectorAll('[data-filters-drawer-toggle]');
  }

  function syncFiltersDrawerA11y() {
    const sidebar = getSidebar();
    if (!sidebar) return;

    const open = isFiltersOpen();

    sidebar.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      sidebar.removeAttribute('inert');
    } else {
      sidebar.setAttribute('inert', '');
    }

    getOpenButtons().forEach((button) => {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (open) {
      const focusTarget =
        sidebar.querySelector('[data-filters-drawer-close]') ||
        (typeof getFocusableElements === 'function' ? getFocusableElements(sidebar)[0] : null);

      if (typeof trapFocus === 'function' && focusTarget) {
        trapFocus(sidebar, focusTarget);
      } else if (focusTarget) {
        focusTarget.focus();
      }
    } else if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(filtersOpener || getOpenButtons()[0]);
      filtersOpener = null;
    }
  }

  function setFiltersOpen(open, opener = null) {
    if (open) {
      filtersOpener = opener || filtersOpener || getOpenButtons()[0];
    }

    document.documentElement.classList.toggle(FILTERS_OPEN_CLASS, open);
    syncFiltersDrawerA11y();
  }

  function toggleFilters(opener) {
    setFiltersOpen(!isFiltersOpen(), opener);
  }

  function initFiltersDrawerA11y() {
    const sidebar = getSidebar();
    if (!sidebar || sidebar.dataset.filtersDrawerA11yInit === 'true') {
      syncFiltersDrawerA11y();
      return;
    }

    sidebar.dataset.filtersDrawerA11yInit = 'true';

    if (!isFiltersOpen()) {
      sidebar.setAttribute('aria-hidden', 'true');
      sidebar.setAttribute('inert', '');
    }

    getOpenButtons().forEach((button) => {
      if (!button.hasAttribute('aria-expanded')) {
        button.setAttribute('aria-expanded', 'false');
      }
    });

    syncFiltersDrawerA11y();
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-filters-drawer-toggle]');
    if (toggle) {
      event.preventDefault();
      toggleFilters(toggle);
      return;
    }

    const close = event.target.closest('[data-filters-drawer-close]');
    if (close) {
      event.preventDefault();
      setFiltersOpen(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.code === 'Escape' && isFiltersOpen()) {
      setFiltersOpen(false);
    }
  });

  document.addEventListener('DOMContentLoaded', initFiltersDrawerA11y);
  document.addEventListener('shopify:section:load', initFiltersDrawerA11y);
})();
